module.exports = __webpack_public_path__ + "static/media/GemischteGruppen01.61f45c6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/GemischteGruppen01.jpg
// module id = 337
// module chunks = 0